import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { saveAs } from 'file-saver';
import { SessionService } from '../../services/session.service';
import { AccountAssessment, Assessment, AssessmentStatus } from '../../models/AssessmentModel';
import { PlatformApiService, ResultFilter } from '../../services/platform-api.service';
import { ReportBuilder } from '../../reporting/ReportBuilder';
import { Account } from '../../models/AccountModel';
import { environment } from '../../../environments/environment';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { GridSpinnerComponent } from 'src/app/shared/grid-spinner.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-company-assessment-dashboard',
  templateUrl: './company-assessment-dashboard.component.html',
  styleUrls: ['./company-assessment-dashboard.component.scss']
})
export class CompanyAssessmentDashboardComponent implements OnInit {
  state;
  selectedAssessment:AccountAssessment;
  assessment: Assessment;
  allowList = false;

  @Input() account:Account;
  @Input() subAccount:Account;
  @ViewChild('spinner', { static: true }) spinner: GridSpinnerComponent;

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router, private _platformApi: PlatformApiService, private _themeManager: ThemeManagerService, public _sessionService: SessionService, public dialog: MatDialog) { }

  ngOnInit() {
    if (!this.account) {
      this.account = this._sessionService.getCurrentAccount();
    }

    if (this._sessionService.hasFeature('DASHBOARD_ENABLED')) {
      this.allowList = true;
    }

    this._activatedRoute.params.subscribe(params => {
      console.log('CompanyAssessmentDashboardComponent:ngOnInit:route', this._activatedRoute.routeConfig.path, params);
      const requestedAssessment = params.assessmentId;

      if (requestedAssessment) {
        this._platformApi.getAccountAssessment(this.account.id, undefined, requestedAssessment).subscribe(aa => {
          this.selectedAssessment = aa;
          if (this.selectedAssessment.status == 'COMPLETED') {
            this.state = 'ASSESSMENT_REPORT';
          } else {
            this.state = 'EDIT_ASSESSMENT';
          }
        });
      } else {
        if (this.allowList) {
          this.state = 'LIST';
        } else {
          this._platformApi.getAccountAssessments(this.account.id, undefined, new ResultFilter('updatedAt', 'desc')).subscribe(assessments => {
            this.selectedAssessment = assessments.results[0];
            if (this.selectedAssessment.status == AssessmentStatus.COMPLETED) {
              this.state = 'ASSESSMENT_REPORT';
            } else {
              this.state = 'EDIT_ASSESSMENT';
            }
          })
        }
      }
    });

    console.log('CompanyAssessmentDashboardComponent.ngOnInit:account', this.account);
  }

  getParentAccount() {
    return this.subAccount !== undefined ? this.account : undefined;
  }

  getWorkingAccount() {
    return this.subAccount !== undefined ? this.subAccount : this.account;
  }

  showList() {
    if (this.allowList) {
      console.log('CompanyAssessmentDashboardComponent:showList:route', 'internal/assessments', {relativeTo:this._activatedRoute.parent});

      this._router.navigate(['internal/assessments'], {relativeTo:this._activatedRoute.parent});

      // this.selectedAssessment = undefined;
      // this.state = 'LIST'
    }
  }
  continueAssessment() {
    this.selectedAssessment.currentPage = 0;
    this.state = 'EDIT';
  }

  onStateChange(event) {
    console.log('CompanyAssessmentDashboardComponent.onStateChange:event', event);

    switch(event.state) {
      case 'ASSESSMENT_REPORT':
      case 'EDIT_ASSESSMENT':
        this.selectedAssessment = event.accountAssessment;
        this._router.navigate([`internal/assessments/${event.accountAssessment.id}`], {relativeTo: this._activatedRoute.parent});
        break;
      case 'COMPLETEDASSESSMENT':
        this.selectedAssessment = event.completedAssessment;
        this.state = 'COMPLETEDASSESSMENT';
        break;
      case 'EDITSUCCESS':
      case 'EDITCANCEL':
        this.selectedAssessment = undefined;
        this.state = 'LIST';
        break;
    }
  }

  getAssessmentReport() {
    const includeAttestation = (this._sessionService.getCurrentAccount().id != this.selectedAssessment.accountId && this._sessionService.hasFeature('INCLUDE_CLIENT_ATTESTATION')) ? true : false;

    if (includeAttestation) {
      const dialogRef = this.dialog.open(ConfirmationComponent, {
        panelClass: 'flush-dialog',
        data: {
          promptTitle: 'Include Attestation?',
          promptMessage: [
            'Do you want to include the attestation page?'
          ],
          closeLabel: 'Cancel',
          buttons: [{label:'No', value:'NO', color:'primary'}, {label:'Yes', value:'YES', color:'primary'}],
          height: 'auto'
        }
      });
      dialogRef.afterClosed().subscribe(includeResponse => {
        if (includeResponse !== undefined) {
          this.downloadReport(includeResponse == 'YES');
        }
      });
    } else {
      this.downloadReport(false);
    }
  }

  downloadReport(includeAttestation:boolean) {
    const self = this;
    self.spinner.showSpinner('Generating report...');
    self._platformApi.getAssessmentReport(
      self._sessionService.getCurrentAccount().id,
      self._sessionService.getCurrentUser().firstName,
      self._sessionService.getCurrentAccount().name,
      self.selectedAssessment,
      includeAttestation,
      self._sessionService.hasFeature('INCLUDE_REPORT_ANALYTICS'),
      self._themeManager.getThemeClass()
    ).subscribe(
      data => {
        if (data) {
          const assessData = this.selectedAssessment
          const blob = new Blob([data], { type: 'application/pdf' });
          saveAs(blob, assessData.accountName+' Assessment Report '+assessData.updatedAt.toLocaleDateString()+'.pdf');
        }
        self.spinner.hideSpinner();
      },
      error => {
        console.log('Error while generating assessment report', error);
        self.spinner.showMessage('An error occurred while generating the report. Please contact an administrator', 5000);
      }
    );
  }
}
